<template>
    <div
        class="TextColumn"
    >
        <div
            class="grid grid--xlarge"
        >
            <div
                v-for="(column, index) in columns"
                :key="index"
                :class="columnClass(index)"
            >
                <div
                    class="TextColumn__item"
                >
                    <BaseText
                        v-if="column.text"
                        :text="column.text"
                    />
                    <BaseImage
                        v-if="column.image"
                        :placeholder="placeholder(index, column)"
                        :srcset="image(index, column)"
                        :ratio="ratio(index, column)"
                        :caption="column.caption"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'TextColumn',
    props: {
        columns: {
            type: Array,
            default: null
        }
    },
    methods: {
        columnClass(index) {
            return {
                'grid__item' : true,
                'lap-and-up-one-third' : index == 0,
                'lap-and-up-two-thirds' : index == 1
            }
        },
        image(index, column) {
            return index == 0 ? column.variant.image : column.image
        },
        placeholder(index, column) {
            return index == 0 ? column.variant.placeholder : column.placeholder
        },
        ratio(index, column) {
            return index == 0 ? column.variant.ratio : column.ratio
        }
    }
}
</script>
<style lang="scss" scoped>

    .TextColumn {

        .has-border & {
            padding: 2.5rem 0;
            border-bottom: 1px solid getColour('grey', 'medium');

            @include media-query(desk) {
                padding: 3rem 0;
            }
        }

        .has-border:last-child & {
            margin-bottom: getSpacing('large');
            border: 0;
        }
    }

    .TextColumn__item {

        .grid__item:last-child & {

            @include media-query(lap) {
                padding-left: getSpacing('large')
            }

            @include media-query(desk) {
                padding-left: getSpacing('xlarge')
            }

            @include media-query(palm) {
                padding-top: getSpacing('spacer')
            }
        }
    }

    .BaseText + .BaseImage {
        margin-top: 2.5rem;
    }

    .TextColumn > .container {
        padding-right: 0;
        padding-left: 0;
        padding-top: getSpacing('medium');
        padding-bottom: getSpacing('medium');
    }

    ::v-deep .BaseImage__caption {
        .grid__item:first-child & {
            position: absolute;
            color: black;
            bottom: - getSpacing(spacer);
            border: 0;
            padding: 0;
            left: 0;
            right: 0;
            opacity: 0.9;
        }
    }

</style>
